import PropTypes from 'prop-types';
import declarations from '../../../PickUpAndDelivery/declarations.proptypes';
import ItemsInOrderTableNotes from '../ItemsInOrderTableNotes';
import ItemsInOrderTablePrice from '../ItemsInOrderTablePrice';
import ItemsInOrderTableName from '../ItemsInOrderTableName/ItemsInOrderTableName';
import ItemsInOrderTableWeight from '../ItemsInOrderTableWeight/ItemsInOrderTableWeight';
import ItemsInOrderTableUnitPrice from '../ItemsInOrderTableUnitPrice';
import ItemsInOrderTableAdditionalInfo from '../ItemsInOrderTableAdditionalInfo/ItemsInOrderTableAdditionalInfo';
import ItemsInOrderTableImage from '../ItemsInOrderTableImage';
import { getDefaultValueFromProp } from '../utils';
import Availability from '@app/components/common/Availability';
import { sourcingDetailsPropTypes } from '@app/components/common/Availability/AvailabilityBySourceContent/AvailabilityBySourceContent.proptypes';
import { ItemGADetailsPropTypes } from '@app/components/pages/checkout/order-confirmation/declarations.proptypes';

const ItemsInOrderTableCondensedRow = ({
  availability,
  coreDeposit,
  currencyNotation,
  discount,
  displayAvailabityAndSourcingDetails,
  extraCharge,
  hoseAssemblyDetails,
  imageSize,
  imageURL,
  includeGST,
  isCheckFreightSuccessful,
  isGuest,
  isQuantityMergeEnabled = true,
  itemGADetails,
  lineItemNotes,
  listName,
  name,
  nonReturnablePartNumber,
  productDisplayUrl,
  prop65Warning,
  remanPartNumber,
  shoppingPreferencesImageSettings,
  showGST,
  showUnitPriceColumn,
  sourcingDetails,
  ssroBundle,
  strikeThrough,
  totalPrice,
  totalPriceWithGST,
  undiscountedPrice,
  unitPrice,
  unitPriceWithGST,
  taxDisclaimerMessage,
  unitWeight,
  storeAvailability
}) => {
  const onScreenImagesPreference = getDefaultValueFromProp(
    shoppingPreferencesImageSettings
  );

  return (
    <div className="d-flex d-print-none">
      {((onScreenImagesPreference && !!imageURL) || isGuest) && (
        <div className="me-3">
          <ItemsInOrderTableImage
            height={imageSize}
            name={name}
            url={imageURL}
            width={imageSize}
          />
        </div>
      )}
      <div>
        <ItemsInOrderTableName
          itemGADetails={itemGADetails}
          listName={listName}
          name={name}
          productDisplayUrl={productDisplayUrl}
        />
        <ItemsInOrderTableWeight unitWeight={unitWeight} />
        <div className="mb-2">
          <ItemsInOrderTablePrice
            coreDeposit={coreDeposit}
            currencyNotation={currencyNotation}
            includeGST={includeGST}
            taxDisclaimerMessage={taxDisclaimerMessage}
            isCheckFreightSuccessful={isCheckFreightSuccessful}
            isCondensedView
            isQuantityMergeEnabled={isQuantityMergeEnabled}
            showGST={showGST}
            showUnitPriceColumn={showUnitPriceColumn}
            strikeThrough={strikeThrough}
            totalPrice={totalPrice}
            totalPriceWithGST={totalPriceWithGST}
            undiscountedPrice={undiscountedPrice}
            unitPrice={unitPrice}
            unitPriceWithGST={unitPriceWithGST}
          />
        </div>
        <div className="mb-2">
          <ItemsInOrderTableUnitPrice
            discount={discount}
            extraCharge={extraCharge}
            unitPrice={unitPrice}
          />
        </div>
        <div className="mb-2">
          <Availability
            availabilityInformation={availability}
            availabilityTypeShowToggle={displayAvailabityAndSourcingDetails}
            hideLabel
            hoseAssemblyDetails={hoseAssemblyDetails}
            sourcingDetailsInformation={sourcingDetails}
            storeAvailability={storeAvailability}
            hideDeliveryCheckoutMessage
          />
        </div>
        <ItemsInOrderTableAdditionalInfo
          nonReturnablePartNumber={nonReturnablePartNumber}
          prop65Warning={prop65Warning}
          remanPartNumber={remanPartNumber}
          ssroBundle={ssroBundle}
        />
        <div className="mb-2 legacy-wrapper">
          <ItemsInOrderTableNotes {...lineItemNotes} />
        </div>
      </div>
    </div>
  );
};

ItemsInOrderTableCondensedRow.propTypes = {
  availability: declarations.availability,
  sourcingDetails: sourcingDetailsPropTypes,
  coreDeposit: PropTypes.string,
  currencyNotation: PropTypes.string,
  discount: PropTypes.string,
  extraCharge: PropTypes.string,
  includeGST: PropTypes.bool,
  taxDisclaimerMessage: PropTypes.string,
  imageSize: PropTypes.string,
  imageURL: PropTypes.string,
  lineItemNotes: declarations.lineItemNotes,
  name: PropTypes.string,
  nonReturnablePartNumber: PropTypes.bool,
  remanPartNumber: PropTypes.bool,
  showGST: PropTypes.bool,
  showUnitPriceColumn: PropTypes.bool,
  shoppingPreferencesImageSettings: PropTypes.arrayOf(
    PropTypes.shape({
      default: PropTypes.bool,
      displayName: PropTypes.string,
      value: PropTypes.string
    })
  ),
  ssroBundle: PropTypes.arrayOf(
    PropTypes.shape({
      selfServiceOptionId: PropTypes.string,
      selfServiceOptionName: PropTypes.string
    })
  ),
  strikeThrough: PropTypes.bool,
  isQuantityMergeEnabled: PropTypes.bool,
  totalPrice: PropTypes.string,
  undiscountedPrice: PropTypes.string,
  unitPrice: PropTypes.string,
  unitWeight: PropTypes.string,
  displayAvailabityAndSourcingDetails: PropTypes.bool,
  hoseAssemblyDetails: PropTypes.shape({
    hoseAssemblyIndicator: PropTypes.bool,
    hoseAvailabilityLabel: PropTypes.string
  }),
  isGuest: PropTypes.bool,
  prop65Warning: PropTypes.string,
  productDisplayUrl: PropTypes.string,
  itemGADetails: ItemGADetailsPropTypes,
  listName: PropTypes.string,
  isCheckFreightSuccessful: PropTypes.bool,
  totalPriceWithGST: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unitPriceWithGST: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ItemsInOrderTableCondensedRow;
